import {CLASS_NAMES} from "@js/constants/constants-imports.es6.js";
import {ATTRIBUTES} from "@js/constants/constants-imports.es6.js";
import Field from "@js/core/field.es6.js";

export default class PrimaryButtonField extends Field {
  disable() {
    this.$().attr(ATTRIBUTES.DISABLED, true);
  }

  enable() {
    this.$().removeAttr(ATTRIBUTES.DISABLED);
  }

  toggleLoadingState(loading) {
    const $this = this.$();
    if (loading) {
      $this.addClass(CLASS_NAMES.LOADING);
    } else {
      $this.removeClass(CLASS_NAMES.LOADING);
    }
  }
}
